import React, { FC, useState } from 'react'
import { Section } from 'components/base/sections/section'
import { H2 } from 'components/base/typography/headings'
import { P } from 'components/base/typography/misc'
import { Auth } from 'aws-amplify'
import toastMessage from 'components/utils/toasts/toasts'
import Button from 'components/base/buttons/buttons'
import { Flex } from 'rebass'
import { RichTextBlock } from 'prismic-reactjs'
// @ts-ignore
import { RichText } from 'prismic-reactjs'
import { RichTextStyleWrapper } from 'components/base/typography/richTextStyleWrapper'

interface Props {
	email: string
	title: RichTextBlock[]
	text: RichTextBlock[]
}

const SignupCompleted: FC<Props> = ({ email, title, text }) => {
	const [loading, setLoading] = useState(false)

	const handleResendCode = async () => {
		setLoading(true)
		try {
			await Auth.resendSignUp(email)
			setLoading(false)
			toastMessage({
				type: 'success',
				title: 'Staðfestingar póstur sendur',
				message: 'Nýr staðfestingarpóstur hefur verið sendur, kíktu á innhólfið þitt',
			})
		} catch (err) {
			setLoading(false)
			toastMessage({
				type: 'error',
				title: 'Ekki tókst að senda staðfestingarpóst',
				message: 'Vinsamlegast hafið samband við þjónustu',
			})
		}
	}

	return (
		<Section mt="3rem" mb="3rem" style={{ textAlign: 'center' }}>
			<H2 mb="3rem">{RichText.asText(title || [])}</H2>
			<RichTextStyleWrapper>{RichText.render(text || [])}</RichTextStyleWrapper>
			<Flex mt="3rem" justifyContent="center">
				<Button ternary onClick={handleResendCode} isLoading={loading}>
					Senda staðfestingarpóst aftur
				</Button>
			</Flex>
		</Section>
	)
}

export default SignupCompleted
